import React from "react";
import PropTypes from "prop-types";
import { CFontIcon } from "@appcues/component-library";
import DropdownButton from "components/Common/DropdownButton";

const ThreeDotsDropdownButton = ({
  handleOnSelect,
  dropdownOptions,
  ...dropdownButtonProps
}) => (
  <DropdownButton
    {...dropdownButtonProps}
    options={dropdownOptions}
    onSelect={handleOnSelect}
    useIconButton
    paddingY={0}
    transparent
  >
    <CFontIcon fontSize="1rem" className="fas fa-ellipsis-h" />
  </DropdownButton>
);

ThreeDotsDropdownButton.propTypes = {
  handleOnSelect: PropTypes.func,
  dropdownOptions: PropTypes.array
};

export default ThreeDotsDropdownButton;
